var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('card',[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('Subscriptions')))]),_c('subscriptions-list',{attrs:{"data":_vm.subscriptions,"loading":_vm.loadingSubscriptions},on:{"changeFilter":_vm.changeFilter,"sort":_vm.sortSubscriptions,"subscriptionDeleted":_vm.fetchSubscriptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }